import { render, staticRenderFns } from "./BaseAjaxbar.vue?vue&type=template&id=ad0745ec&"
import script from "./BaseAjaxbar.vue?vue&type=script&lang=ts&"
export * from "./BaseAjaxbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports